<!-- 分配 -->
<template>
  <div class="import-tool">
    <Modal
      v-model="visible"
      title="分配"
      :mask-closable="false"
      width="420"
      :footer-hide="true"
      class="my-modal top import-tool-modal2"
    >
      <my-form class="myFormStyle" :formList="formData" ref="form"></my-form>
      <div class="confirm" @click="ok">确认</div>
    </Modal>
  </div>
</template>
<script>
import selectTree from "@/components/commons/selectTree";
import myForm from "@/components/commons/form";
import formData from "./distributionForm";

export default {
  props:['getInsureList'],
  components: {
    selectTree,
    myForm,
  },
  data() {
    return {
      visible: false,
      formData: [],
      from:{}
    };
  },
  methods: {
    open(data) {
      this.$refs.form && this.$refs.form.resetFields();
      this.formData = formData(this);
      this.from.customerId = data.id;
      this.getOrgTree(data.organizationId);
      this.visible = true;
    },

    dealTree(arr) {
      return arr.map((item) => ({
        ...item,
        value: item,
        label:item.name?item.name:item.label,
        children:
          item.children && item.children.length > 0 ? this.dealTree(item.children) : null
      }));
    },

    // 获取机构
    getOrgTree(orgId) {
      this.$http({
        url: `/buz/organizationBase/read/orgTree`,
        type: "POST",
        data:{
          source:2,
          orgId
        }
      }).then((res) => {
        this.formData[0].data[0].arr = this.dealTree([res.data]);
      });
    },

    ok() {
      this.$refs.form.validate((valid, obj) => {
        if (!valid) {
          return;
        }
        this.submit(obj);
      });
    },

    submit(obj) {
      this.from.agentId = obj.agentId;
      this.$http({
        url: `/buz/customerDistributionRecord/add`,
        type: "POST",
        data:this.from
      }).then((res) => {
        this.visible = false;
        this.getInsureList();
        this.$notice.success("分配成功");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
  .myFormStyle {
    padding-left: 0px;
  }

  .ivu-modal-body {
    padding-bottom: 40px;
  }
  .ivu-modal-header-inner {
    font-size: 14px;
    font-weight: bold;
    color: #3c464f;
  }
  .ivu-modal-close {
    top: 4px;
    .ivu-icon-ios-close {
      font-size: 30px;
      color: #a8adb7;
    }
  }
  .ivu-modal-header {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
  .confirm {
    margin: 0 auto;
    width: 100px;
    height: 30px;
    background-color: #236dff;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #fff;
  }
}

/deep/ .ivu-form-item-label {
  font-size: 12px !important;
}
/deep/ .treeNode {
  font-size: 12px !important;
}
/deep/ .ivu-select-placeholder {
  font-size: 12px !important;
}
</style>
